import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import type { ScrollHiddenItemsHintProps } from './ScrollHiddenItemsHint.props';
import { ScrollHiddenItemsHintRoot } from './ScrollHiddenItemsHint.styles';

const getScrollHintLabel = (count: number, singularLabel: string, pluralLabel: string) =>
  `${count} ${count === 1 ? singularLabel : pluralLabel}`;

const ScrollHiddenItemsHint = ({
  count,
  itemLabelPlural,
  itemLabelSingular,
  placement,
  ...props
}: ScrollHiddenItemsHintProps) => {
  const label = getScrollHintLabel(count, itemLabelSingular, itemLabelPlural);
  const directionLabel = placement === 'top' ? 'above' : 'below';

  return (
    <ScrollHiddenItemsHintRoot
      aria-label={`Show ${count} hidden ${itemLabelPlural} ${directionLabel}`}
      placement={placement}
      {...props}>
      {placement === 'top' ? <ArrowUpward fontSize="inherit" /> : <ArrowDownward fontSize="inherit" />}
      {label}
    </ScrollHiddenItemsHintRoot>
  );
};

export default ScrollHiddenItemsHint;
